import { render, staticRenderFns } from "./menu_block.vue?vue&type=template&id=61925c3a&scoped=true&"
import script from "./menu_block.vue?vue&type=script&lang=js&"
export * from "./menu_block.vue?vue&type=script&lang=js&"
import style0 from "./menu_block.vue?vue&type=style&index=0&id=61925c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61925c3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61925c3a')) {
      api.createRecord('61925c3a', component.options)
    } else {
      api.reload('61925c3a', component.options)
    }
    module.hot.accept("./menu_block.vue?vue&type=template&id=61925c3a&scoped=true&", function () {
      api.rerender('61925c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/menu/menu_block.vue"
export default component.exports